import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE3_6 = () => (
  <Section>

    <P>
      Fortgeschrittene SuS können in Partnerarbeit auch eine eigene Grafik erstellen:
    </P>

    <UL disc>
      <LI>
        <P gapBefore>
          Einflüsse auf Umwelt und Mensch
        </P>
        <UL square>
          <LI>in der Produktion</LI>
          <LI>im Gebrauch und</LI>
          <LI>in der Entsorgung</LI>
        </UL>
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE3_6.js